import { Form, Row, Col } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";

import { useDirectorySearch } from "../../hooks/useDirectorySearch";
import { formatPhoneNumber } from "../../../../../Utils/helper";
import ContactPanelForEditPopups from "../../../../TreatmentPage/components/ContactPanelForEditPopups";
import StateSelect from "../insurance/components/StateSelect";
import AutoCompleteSearch from "../../../../Insurance/AutoCompleteSearch";
import { registerCapitalized } from "../insurance/components/InsurancePartyFieldset";

import { firmSearchConfig } from "./config/counselSearchConfig";

const COUNSEL_FIELDS = [
  "counsel_id",
  "counsel_name",
  "counsel_address1",
  "counsel_address2",
  "counsel_city",
  "counsel_state",
  "counsel_zip",
  "counsel_phone",
  "counsel_extension",
  "counsel_fax",
  "counsel_email",
  "counsel_website",
];

const CounselFirmFields = ({ entityId, statesData }) => {
  const { register, control, setValue } = useFormContext();
  const f = (field) => `counsel.${entityId}.${field}`;
  const search = useDirectorySearch(firmSearchConfig, {
    entityScope: "counsel",
    entityId,
  });

  const watched = useWatch({
    control,
    name: COUNSEL_FIELDS.map(f),
  });
  const [, name, address1, address2, city, , zip, phone, ext, fax, email, website] = watched;
  const state = useWatch({ control, name: f("counsel_state") });

  return (
    <>
      <Row className="custom-margin-bottom p-l-5 p-r-5 m-t-5 mx-0">
        <Col md={12} className="p-l-0 p-r-0 position-relative">
          <input
            type="text"
            className="form-control rounded-0 height-25"
            placeholder="Type Counsel Name or Firm Name to add from library"
            value={search.searchTerm}
            onChange={search.onInputChange}
          />
          {search.searchTerm && (
            <span
              onClick={() => search.clearSelection(COUNSEL_FIELDS)}
              style={{
                position: "absolute",
                right: 12,
                top: 5,
                cursor: "pointer",
                fontSize: 14,
                lineHeight: 1,
                userSelect: "none",
              }}
            >
              ✕
            </span>
          )}
          {search.results.length > 0 && (
            <AutoCompleteSearch
              searchedInsurances={search.results}
              selectedInsurance={(id) => search.applySelection(id)}
              isCounsel
            />
          )}
        </Col>
      </Row>

      <Row className="mx-0 p-l-5 p-r-5">
        <ContactPanelForEditPopups
          name={name}
          panel_name="Opposing Counsel"
          pageName="Witnesses"
          className="m-b-5"
          dynamic_label="Opposing Counsel Name"
          phone_number={phone}
          fax_number={fax}
          email={email}
          address1={address1}
          address2={address2}
          websiteURL={website}
          city={city}
          state={state}
          zip_code={zip}
          ext={ext}
          buttonData={[]}
        />

        <Col md="auto" className="p-0 d-flex-1">
          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="Name"
                className="form-control rounded-0 height-25"
                {...registerCapitalized(register, setValue, f("counsel_name"))}
              />
            </div>
          </Row>

          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1 p-r-5">
              <Form.Control
                type="text"
                placeholder="Address 1"
                className="form-control rounded-0 height-25"
                {...registerCapitalized(register, setValue, f("counsel_address1"))}
              />
            </div>
            <div className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="Address 2"
                className="form-control rounded-0 height-25"
                {...registerCapitalized(register, setValue, f("counsel_address2"))}
              />
            </div>
          </Row>

          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1 p-l-0 p-r-5">
              <Form.Control
                type="text"
                placeholder="City"
                className="form-control rounded-0 height-25"
                {...registerCapitalized(register, setValue, f("counsel_city"))}
              />
            </div>
            <StateSelect name={f("counsel_state")} statesData={statesData} />
            <div style={{ maxWidth: 90 }} className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="Zip"
                className="form-control rounded-0 height-25"
                {...register(f("counsel_zip"))}
              />
            </div>
          </Row>

          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1 p-r-5 p-l-0">
              <Form.Control
                type="text"
                placeholder="(###) ###-####"
                maxLength={14}
                className="form-control rounded-0 height-25"
                {...register(f("counsel_phone"), {
                  onChange: (e) => setValue(f("counsel_phone"), formatPhoneNumber(e.target.value)),
                })}
              />
            </div>
            <div style={{ maxWidth: 90 }} className="d-flex-1 p-r-5">
              <Form.Control
                type="text"
                placeholder="Ext"
                className="form-control rounded-0 height-25"
                {...register(f("counsel_extension"), {
                  onChange: (e) =>
                    setValue(f("counsel_extension"), e.target.value.replace(/[^0-9]/g, "")),
                })}
              />
            </div>
            <div className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="(###) ###-####"
                maxLength={14}
                className="form-control rounded-0 height-25"
                {...register(f("counsel_fax"), {
                  onChange: (e) => setValue(f("counsel_fax"), formatPhoneNumber(e.target.value)),
                })}
              />
            </div>
          </Row>

          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="Email"
                className="form-control rounded-0 height-25"
                {...register(f("counsel_email"))}
              />
            </div>
          </Row>

          <Row className="custom-margin-bottom mx-0">
            <div className="d-flex-1">
              <Form.Control
                type="text"
                placeholder="Website"
                className="form-control rounded-0 height-25"
                {...register(f("counsel_website"))}
              />
            </div>
          </Row>
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              onClick={() => search.clearSelection(COUNSEL_FIELDS)}
              style={{
                cursor: "pointer",
                fontSize: 14,
                lineHeight: 1,
                userSelect: "none",
                minWidth: "80px",
              }}
              className="btn btn-primary height-25 p-0"
            >
              Clear
            </button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CounselFirmFields;
